/**
 * Sale dates from the API often look like YYYY-MM-DD or ISO strings starting with that.
 * `new Date("2025-08-29")` parses as UTC midnight, which becomes the previous calendar day
 * in US timezones when formatted with toLocaleDateString — off by one vs moment (local) and
 * vs <input type="date"> (local calendar).
 */
export function parseSaleDateLocal(val) {
  if (val === undefined || val === null || val === "") return null;
  const s = String(val).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const y = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    const d = parseInt(m[3], 10);
    const date = new Date(y, mo, d);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(s);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** YYYY-MM-DD for <input type="date"> from API or form value */
export function formatYmdFromSaleDateValue(val) {
  const d = parseSaleDateLocal(val);
  if (!d) return "";
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}
